<template>
  <b-container fluid class="mt-5">
    <div class="card shadow">
      <div class="card-body">
        <div class="row">
          <div :class="[mobileView ? 'col-lg-12' : 'col-lg-12 mx-auto']">
            <canvas id="metrique-chart"></canvas>
            <br />
            <br />
            <br />
            <br />
          </div>
          <div
            :class="[mobileView ? 'col-lg-12' : 'col-lg-12 mx-auto']"
            v-if="$route.params.metrique == 'taux_rendez_vous'"
          >
            <canvas id="layanan"></canvas>
          </div>

          <div class="col-lg-12 mt-4">
            <p class="text-center font-weight-bold">{{ description }}</p>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
import router from "../../router/router";
import AppConfig from "../../constants/AppConfig";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
export default {
  name: "Detail",
  data() {
    return {
      metriqueData: {},
      mobileView: true,
      loader: true,
      title: "",
      description: "",
      type: 30,
    };
  },
  methods: {
    handleView() {
      this.mobileView = window.innerWidth <= 990;
    },
    recuperationParMois() {
      let date = this.type,
        metrique = this.$route.params.metrique;
      switch (this.$route.params.metrique) {
        case "temps_moyen":
          this.title = "Temps moyens de prise en charge";
          this.description =
            "Graphe présentant l'évolution moyen du temps de prise en charge";
          break;
        case "nbre_patients":
          this.title = "Nombres de patients sur la base de calcul";
          this.description =
            "Graphe présentant l'évolution du nombre de patient pris en compte pour le calcul des délais";
          break;
        case "activite_amas":
          this.title = "Délai des Activités Administratives";
          this.description =
            "Graphe présentant les délais des activités administratives";
          break;
        case "affiliation_et_affectation_medecin_referents":
          this.title =
            "Délai entre affiliation et affectation du medécin reférent";
          this.description =
            "Délai entre l'appel Souscripteur et la notification au Médecin Référent";
          break;
        case "consultation_examen_validation":
          this.title = "Délai de Validation des examnens par le souscripteur";
          this.description =
            "Moyenne de délai entre toute demande de validation financière et Validation par l'entité qui finance (souscripteur...)";
          break;
        case "consultation_fichier":
          this.title = "Délai de production des rapports après consultations";
          this.description =
            "graphe présentant le délai de production des rapports après consultations";
          break;
        case "consultation_medecine_generale":
          this.title =
            "Délai entre Affectation du médécin reférent et Consultations";
          this.description =
            "Délai de mise à disposition systématique d'un rapport de synthèse après la consultation";
          break;
        case "medecin_controle":
          this.title = "Délai Activités Médécins référents";
          this.description =
            "Graphe présentant les délais Activités Médécins référents";
          break;
        case "resultat_imagerie":
          this.title =
            "Délai entre la Consultation médécine générale et les Résultats Imageries";
          this.description = "Délai de production des Résultats d'imageries";
          break;
        case "resultat_labo":
          this.title =
            "Délai entre la Consultation médécine générale et les Résultats Laboratoires";
          this.description =
            "Délai de production des Résultats de laboratoires";
          break;
        case "avis_medicals":
          this.title =
            "Délai d'attente entre l'emission des médicaux et leurs réponses";
          this.description = "Délai entre demande  d'avis et réponse à l'avis";
          break;
        case "taux_rendez_vous":
          this.title = "Taux de rendez-vous";
          this.description = "Taux des différents états de rendez-vous";
          break;
        default:
          break;
      }
      fetch(AppConfig.apiUrl + `/v1/metriques/${date}/${metrique}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("ms-token"),
        },
      })
        .then((res) => {
          if (res.status == 401) {
            localStorage.setItem("ancestor_link", window.location.href);
            router.push({ name: "login" });
            Vue.swal({ type: "error", title: error.message });
          }
          return res.json();
        })
        .then((res) => {
          let step =
              metrique == "taux_rendez_vous"
                ? 1
                : Number(Math.max(...res.courbe.data.datasets[0].data) / 15),
            title =
              this.$route.params.metrique == "nbre_patients"
                ? "Patient"
                : this.$route.params.metrique == "taux_rendez_vous"
                ? "Rendez-vous"
                : "Durée";
          let courbe = {
            data: res.courbe.data,
            options: {
              scales: {
                xAxes: [
                  {
                    display: true,
                    scaleLabel: {
                      display: true,
                      labelString: "Date",
                      fontSize: 16,
                      fontStyle: "bold",
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      userCallback: function (seconde) {
                        let sec = Math.round(seconde);
                        var y = Math.floor(sec / 31536000); //<<years
                        var w = Math.floor(y * 31536000);
                        var w1 = Math.floor(w - sec);
                        w = Math.floor(Math.abs(w1) / 604800); //<<weeks
                        var d = Math.floor(Math.abs(w) * 604800);
                        var d1 = Math.floor(Math.abs(d) - Math.abs(w1));
                        d = Math.floor(Math.abs(d1) / 86400);
                        d = Math.abs(d); //<<day
                        var h = Math.floor(d * 86400);
                        h = Math.floor(h - Math.abs(d1));
                        h = Math.floor(Math.abs(h) / 3600); //<<hours
                        var m = Math.floor((sec % 3600) / 60); //<<minutes

                        var yDisplay =
                          y > 0 ? y + (y == 1 ? " an " : " ans ") : "";
                        var wDisplay =
                          w > 0 ? w + (w == 1 ? " sem " : " sem ") : "";
                        var dDisplay =
                          d > 0 ? d + (d == 1 ? " j " : " j ") : "";
                        var hDisplay =
                          h > 0 ? h + (h == 1 ? " h " : " h ") : "";
                        var mDisplay =
                          m > 0 ? m + (m == 1 ? " min " : " min ") : "";
                        return metrique == "nbre_patients" ||
                          metrique == "taux_rendez_vous"
                          ? sec.toLocaleString()
                          : yDisplay +
                              wDisplay +
                              dDisplay +
                              hDisplay +
                              mDisplay;
                      },
                      stepSize: step,
                    },
                    scaleLabel: {
                      display: true,
                      labelString: title,
                      fontSize: 16,
                      fontStyle: "bold",
                    },
                  },
                ],
              },
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {
                    let sec = Math.round(tooltipItem.yLabel);
                    var y = Math.floor(sec / 31536000); //<<years
                    var w = Math.floor(y * 31536000);
                    var w1 = Math.floor(w - sec);
                    w = Math.floor(Math.abs(w1) / 604800); //<<weeks
                    var d = Math.floor(Math.abs(w) * 604800);
                    var d1 = Math.floor(Math.abs(d) - Math.abs(w1));
                    d = Math.floor(Math.abs(d1) / 86400);
                    d = Math.abs(d); //<<day
                    var h = Math.floor(d * 86400);
                    h = Math.floor(h - Math.abs(d1));
                    h = Math.floor(Math.abs(h) / 3600); //<<hours
                    var m = Math.floor((sec % 3600) / 60); //<<minutes

                    var yDisplay = y > 0 ? y + (y == 1 ? " an " : " ans ") : "";
                    var wDisplay =
                      w > 0 ? w + (w == 1 ? " sem " : " sem ") : "";
                    var dDisplay = d > 0 ? d + (d == 1 ? " j " : " j ") : "";
                    var hDisplay = h > 0 ? h + (h == 1 ? " h " : " h ") : "";
                    var mDisplay =
                      m > 0 ? m + (m == 1 ? " min " : " min ") : "";
                    return metrique == "nbre_patients" ||
                      metrique == "taux_rendez_vous"
                      ? sec.toLocaleString()
                      : yDisplay + wDisplay + dDisplay + hDisplay + mDisplay;
                  },
                },
              },
            },
            plugins: [ChartDataLabels],
            type: "line",
          };

          this.metriqueData = courbe;
          this.loader = false;
          const ctx = document.getElementById("metrique-chart");
          new Chart(ctx, this.metriqueData);
          /**
           * Deuxième
           */
          if (metrique == "taux_rendez_vous") {
            var layanan = document.getElementById("layanan").getContext("2d");
            var data = {
              datasets: [
                {
                  data: res.courbe_pie_charts,
                  backgroundColor: [
                    "#3c8dbc",
                    "#f56954",
                    "#f39c12",
                    "#7283D4",
                    "#538E3D",
                  ],
                },
              ],
              labels: [
                "Rendez-vous Manqués",
                "Rendez-vous Annulés",
                "Rendez-vous Reprogrammés",
                "Rendez-vous effectués",
                "Rendez-vous programmés",
              ],
            };
            var myDoughnutChart = new Chart(layanan, {
              type: "doughnut",
              data: data,
              options: {
                responsive: true,
                maintainAspectRatio: true,
                legend: {
                  position: "bottom",
                  labels: {
                    boxWidth: 12,
                  },
                },
                plugins: {
                  datalabels: {
                    formatter: (value, ctx) => {
                      let datasets = ctx.chart.data.datasets;
                      if (
                        datasets.indexOf(ctx.dataset) ===
                        datasets.length - 1
                      ) {
                        let sum = datasets[0].data.reduce((a, b) => a + b, 0);
                        let percentage = ((value / sum) * 100).toFixed(2) + "%";
                        return percentage;
                      } else {
                        return percentage;
                      }
                    },
                    color: "#000",
                  },
                },
                tooltips: {
                  callbacks: {
                    label: function (tooltipItem, data) {
                      let sum = data.datasets[0].data.reduce(
                        (a, b) => a + b,
                        0
                      );
                      let value = data.datasets[0].data[tooltipItem.index];
                      let percentage = ((value / sum) * 100).toFixed(2) + "%";
                      return (
                        value +
                        " sur un total de " +
                        sum +
                        " soit " +
                        percentage
                      );
                    },
                  },
                },
              },
            });
          }
        })
        .catch((error) => {
          console.log("error ", error);
        });
    },
  },
  mounted() {
    this.recuperationParMois();
  },
  created() {
    this.handleView();
    window.addEventListener("resize", this.handleView);
  },
};
</script>
